import {
    MEMBER_REGISTER_PENDING,
    MEMBER_REGISTER_SUCCESS,
    MEMBER_REGISTER_ERROR
} from "../../actions/guests/member_register_action";

const initialState = {
    pending: false,
    error: null
};

export function memberRegister(
    state = { ...initialState, memberRegister: null },
    action
) {
    switch (action.type) {
        case MEMBER_REGISTER_PENDING:
            return {
                ...state,
                pending: true,
            };
        case MEMBER_REGISTER_SUCCESS:
            return {
                ...state,
                pending: false,
                memberRegister: action.data,
            };
        case MEMBER_REGISTER_ERROR:
            return {
                ...state,
                pending: false,
                error: action.error,
            };
        default:
            return state;
    }
}

export const getMemberRegisterPending = (state) => state.pending;
export const getMemberRegister = (state) => state.memberRegister;
export const getMemberRegisterError = (state) => state.error;